import { render, staticRenderFns } from "./ImageFullCarousel.vue?vue&type=template&id=3534c058&scoped=true&"
import script from "./ImageFullCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageFullCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ImageFullCarousel.vue?vue&type=style&index=0&id=3534c058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3534c058",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VContainer,VDialog,VIcon})
